import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import StudypackVideoPlayer from "../Vedio-player/StudypackVideoPlayer";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const StudyPackRecordingsComponent = (props) => {
  const [open, setOpen] = React.useState(false);


  const {
    _id,
    videoUrl,
    title,
    description,
    limit,
    lessonId,
    thumbnail,
    watchTime,
  } = props.video;

  return (
    <div>
      <Card
        sx={{
          margin: "10px",
          boxShadow: "10px 10px 10px 10px rgba(0,0,0,0.2)",
        }}
      >
        {/* <CardMedia sx={{ height: 240 }} image={heroImg} title="green iguana" /> */}
        <StudypackVideoPlayer
          url={videoUrl}
          thumbnail={thumbnail}
        />
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </div>
        </CardContent>
        {/* <CardActions>
          {watchTime === null ? (
            <Button size="small">
              Remaining number of times{" "}
              <Typography
                sx={{
                  color: "green",
                  fontWeight: "bold",
                  marginLeft: "10px",
                  marginBottom: "5px",
                  fontSize: "20px",
                }}
              >
      
                {limit}
              </Typography>
            </Button>
          ) : (
            <Button size="small">
              Remaining number of times{" "}
              <Typography
                sx={{
                  color: limit - watchTime.watchCount > 3 ? "green" : "red",
                  fontWeight: "bold",
                  marginLeft: "10px",
                  marginBottom: "5px",
                  fontSize: "20px",
                }}
              >
                {" "}
                {limit - watchTime.watchCount}
              </Typography>
            </Button>
          )}
        </CardActions> */}
      </Card>
    </div>
  );
};
